import router from "@/router/router.js";

export default function logOut() {
  localStorage.removeItem('token');
  location.reload();
  router.push('/login');
}